import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createNoticeTemplate,
  getAllNoticeTemplates,
  getNoticeTemplatesByOrganization,
  getNoticeTemplateById,
  updateNoticeTemplate,
  deleteNoticeTemplate,
  searchAgreementsForNoticeTemplate,
  generateNoticesFromTemplate,
} from "../../../api/noticeTemplates_api";

export const createNoticeTemplateAction = createAsyncThunk(
  "noticeTemplateGenerater/createNoticeTemplate",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createNoticeTemplate(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getAllNoticeTemplatesAction = createAsyncThunk(
  "noticeTemplateGenerater/getAllNoticeTemplates",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getAllNoticeTemplates(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getNoticeTemplatesByOrganizationAction = createAsyncThunk(
  "noticeTemplateGenerater/getNoticeTemplatesByOrganization",
  async (data, { rejectWithValue }) => {
    try {
      const response = await getNoticeTemplatesByOrganization(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getNoticeTemplateByIdAction = createAsyncThunk(
  "noticeTemplateGenerater/getNoticeTemplateById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await getNoticeTemplateById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateNoticeTemplateAction = createAsyncThunk(
  "noticeTemplateGenerater/updateNoticeTemplate",
  async ({ Id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateNoticeTemplate(Id, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteNoticeTemplateAction = createAsyncThunk(
  "noticeTemplateGenerater/deleteNoticeTemplate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteNoticeTemplate(id);
      return { id, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const searchAgreementsForNoticeTemplateAction = createAsyncThunk(
  "noticeTemplateGenerater/searchAgreementsForNoticeTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchAgreementsForNoticeTemplate(payload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to search agreements",
      );
    }
  },
);

export const generateNoticesFromTemplateAction = createAsyncThunk(
  "noticeTemplateGenerater/generateNoticesFromTemplate",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await generateNoticesFromTemplate(formData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
